import { Container, Col } from 'reactstrap';
import React, { useState } from 'react';
import { Accordion, AccordionBody, AccordionHeader, AccordionItem } from 'reactstrap';
import styles from './styles.module.scss';

export const AccordionsNew= ({
    className,
    title,
    icon_color,
    heading,
    titleColour,
    items
}) => {

    // Create a state variable to track the open accordion item and its toggle class
    const [openItem, setOpenItem] = useState(null);

    const classToggle = (id) => {
        // If the clicked item is already open, close it
        if (openItem === id) {
            setOpenItem(null);
        } else {
            // Otherwise, open the clicked item
            setOpenItem(id);
        }
    };

    const [open, setOpen] = useState('');
    const toggle = (id) => {
        if (open === id) {
            setOpen();
        } else {
            setOpen(id);
        }
    };

    return (
        <section className={`${styles.root} ${className} bg-light`}>
            <Container className="py-4 py-md-5">
                {title &&
                    <div className="mb-5 heading">
                        <h2
                            className={`text-${titleColour?.variant} ${heading} m-0`}
                            style={titleColour?.custom ? { color: titleColour?.custom } : null}
                        >
                            {title}
                        </h2>
                    </div>
                }
                <Accordion open={open} toggle={toggle} className="row row-cols-1 row-cols-md-2 row-cols-lg-5 m-0">
                    {items?.map((item, index) => (
                        <Col key={index} className={`mb-4 item rounded-4 ${open === `${index}` ? "open" : ""}`} style={{ "--icon-color": item.icon_color?.custom ?? item.icon_color?.variant ?? undefined }}>
                            <AccordionItem className={`border-0 bg-transparent position-relative`}>
                                {/* <AccordionHeader
                                    targetId={`${index}`}
                                    tag="div"
                                    className={`mb-4`}
                                    onClick={() => classToggle(`${index}`)}
                                >
                                    {item?.title}
                                </AccordionHeader> */}
                                                               <AccordionHeader
                                    targetId={`${index}`}
                                    tag="div"
                                    className={`${item.url_slug ? "stretched-link" : ""} mb-4`}
                                    onClick={() => { item.url_slug ? window.location.href = item.url_slug : classToggle(`${index}`); }}
                                >
                                    {item?.title}
                                </AccordionHeader>
                                {item?.short_description &&
                                    <div dangerouslySetInnerHTML={{ __html: item?.short_description }} />
                                }
                                <AccordionBody accordionId={`${index}`}>
                                    {item?.content &&
                                        <div dangerouslySetInnerHTML={{ __html: item?.content }} />
                                    }
                                </AccordionBody>
                            </AccordionItem>
                        </Col>
                    ))}
                </Accordion>
            </Container>
        </section>
    )
}

export default AccordionsNew;
